import { Sheet, SheetContent, SheetTrigger } from '@design-system/Sheet';
import { Info } from 'lucide-react';
import { PriceInfo } from './ShopPageViews';
import { TickMarkIcon } from '@/components/icons/TickMarkIcon';
import EventTracker from '@/utils/EventTracker';
import { analyticsEvent } from '@utils/analyticsEvent';

interface PriceDiscountSheetProps {
  priceInfo: PriceInfo;
}

export const PriceDiscountSheet = ({ priceInfo }: PriceDiscountSheetProps) => {
  const monthlyPriceWithoutDiscount = parseFloat(
    priceInfo.monthlyPriceWithOutDiscount,
  );
  const displayMonthlyPrice = parseFloat(priceInfo.displayMonthlyPrice);
  const priceDifference = (
    monthlyPriceWithoutDiscount - displayMonthlyPrice
  ).toFixed(2);
  const offerDurationMonths = priceInfo.offerDuration?.split(' ')[0] || '';
  const month = Number(offerDurationMonths);
  const isValidDuration = month && month > 0 && month < 12;

  const handleTrackEvent = () => {
    EventTracker.trackEvent('shop', analyticsEvent.SHOP_MYFORMULAS_PRICE_TAG_INFO);
  };

  return (
    <Sheet>
      <SheetTrigger onClick={handleTrackEvent}>
        <Info size={18} className="inline text-tertiary" />
      </SheetTrigger>
      <SheetContent className="w-full md:w-[400px]">
        <div className="flex flex-col p-6 space-y-4 justify-center h-full mx-auto max-w-[264px]">
          {Number(priceDifference) > 0 && (
            <div className="flex items-center">
              <TickMarkIcon className="mr-3 flex-shrink-0 mt-1" />
              <p className="typography-title text-background-success">
                {isValidDuration
                  ? `Save $${priceDifference}/month for ${offerDurationMonths} months`
                  : `Save ${priceDifference}/month`}
              </p>
            </div>
          )}
          <div className="flex items-center">
            <TickMarkIcon className="mr-3 flex-shrink-0 mt-1" />
            <p className="typography-body">
              30-day supply, paid & delivered monthly
            </p>
          </div>
          <div className="flex items-center">
            <TickMarkIcon className="mr-3 flex-shrink-0 mt-1" />
            <p className="typography-body">Pause or cancel anytime</p>
          </div>
          {Boolean(isValidDuration) && (
            <div className="flex items-center">
              <TickMarkIcon className="mr-3 flex-shrink-0 mt-1" />
              <p className="typography-body">
                Pay ${priceInfo.displayMonthlyPrice}/month during the first{' '}
                {offerDurationMonths} months; $
                {priceInfo.monthlyPriceWithOutDiscount}
                /month after {offerDurationMonths} months
              </p>
            </div>
          )}
        </div>
      </SheetContent>
    </Sheet>
  );
};
